const UiMeet3dEventNotificationType = {
  EMAIL: 0,
  SMS: 1,
  WEBHOOK: 2,
};

export default UiMeet3dEventNotificationType;
